import React, { useRef, useState } from "react";
import InputBox from "../InputBox/InputBox";
import Button from "../Button/Button";
import { isValidObject } from "../../Services/validators";
import { PencilIcon, UserIcon } from "../../Assets/assets";
import { getInitials } from "../../Utils/Constants/Constants";

export function ProfileHeader(props) {
  const [name, setName] = useState(props.name || "");
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);

  const initialsStyle = {
    background: props.isOpen
      ? "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%)"
      : "var(--tertiaryColor3)",
    borderRadius: "50%",
    width: props.isOpen ? "80px" : "44px",
    height: props.isOpen ? "80px" : "44px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    fontSize: props.isOpen ? "30px" : "16px",
    fontWeight: "500",
    cursor: props.isOpen && "pointer",
    position: "relative"
  };

  const handleFileClick = () => {
    if (!props.edit) {
      return;
    }
    if (props.activeDropdown === "profile") {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (event) => {
    if (!props.edit) {
      return;
    }
    const file = event.target.files[0];
    if (!file) return;

    const validFileTypes = ["image/jpeg", "image/jpg", "image/png"];
    if (!validFileTypes.includes(file.type)) {
      props.setErrorStatus({
        code: "custom",
        message: "Kindly upload a valid File"
      });
    } else if (file.size > 250000) {
      props.setErrorStatus({
        code: "input/file-size-exceeded",
        message: "Document size should be less than 5MB"
      });
    } else {
      setSelectedFile({ file, previewUrl: URL.createObjectURL(file) });
    }
  };

  return props.isOpen ? (
    <div
      className="padding-large"
      style={{
        opacity: props.blur ? "40%" : "100%",
        backgroundColor: props.isOpen
          ? "var(--tertiaryColor3)"
          : "var(--secondaryColor)"
      }}
    >
      <div className="display-flex flex-justify-content-space-between flex-align-items-center inherit-parent-width  margin-top-large">
        {props.fileSrc || isValidObject(selectedFile) ? (
          <form
            className="cursor-pointer position-relative"
            onChange={handleFileChange}
            data-cy="upload-picture"
          >
            <input
              type="file"
              accept=".jpg,.jpeg,.png"
              name="fileUploaderInput"
              onClick={(event) => (event.target.value = "")}
              className="visibility-hidden position-absolute"
            />
            <img
              style={{
                width: "80px",
                height: "80px",
                borderRadius: "50%",
                position: "relative"
              }}
              src={
                isValidObject(selectedFile)
                  ? selectedFile.previewUrl
                  : props.fileSrc
              }
              alt="profileImage"
            />
            <div className="position-absolute bottom-0" style={{ left: "50%" }}>
              <PencilIcon color="var(--tertiaryColor6)" />
            </div>

            {props.hover && <div></div>}
          </form>
        ) : (
          <form className="margin-bottom-default">
            {props.edit && (
              <input
                ref={fileInputRef}
                type="file"
                accept=".jpg,.jpeg,.png"
                name="fileUploaderInput"
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
            )}
            <div style={initialsStyle} onClick={handleFileClick}>
              {name && (
                <div className="font-color-tertiaryColor6">
                  {getInitials(name)}
                </div>
              )}
              {!name && (
                <div style={{ width: "fit-content", height: "fit-content" }}>
                  <UserIcon
                    width="24"
                    height="24"
                    color="var(--tertiaryColor6)"
                  />
                </div>
              )}
              {props.edit && (
                <div
                  className="position-absolute bottom-0"
                  data-cy="profile-edit-icon"
                >
                  <PencilIcon color="var(--tertiaryColor6)" />
                </div>
              )}
            </div>
          </form>
        )}
        <div
          style={{
            width: "70%"
          }}
        >
          <InputBox
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            label="Name"
            name="Name"
            size="half"
            className="inherit-parent-width"
            labelFontColor="font-color-tertiaryColor"
            fontColor="font-color-tertiaryColor"
            removeResponsive={true}
            data-cy="profile-name-input-box"
          />
        </div>
      </div>

      <div className="display-flex margin-top-larger">
        <div
          style={{
            width: "60%"
          }}
        >
          <Button
            text="Save changes"
            boxShadow={false}
            data-cy="save-changes-button"
            onClick={() => {
              props.updateProfile(
                {
                  data: props?.selectedFile?.file,
                  type: props?.fileSrc ? "update" : "create"
                },
                { name: name }
              );
              props.setActive(null);
            }}
          />
        </div>
        <div
          style={{
            width: "40%"
          }}
        >
          <Button
            data-cy="CANCEL-BUTTON"
            variant="transparent"
            text="Cancel"
            boxShadow={false}
            className="inherit-parent-width padding-left-large padding-right-large"
            onClick={() => {
              props.setActive(null);
              setName(props.name || "");
            }}
          />
        </div>
      </div>
    </div>
  ) : (
    <div
      className="flex-justify-content-space-between flex-align-items-center margin-vertical-large padding-horizontal-large"
      style={{ opacity: props.blur ? "40%" : "100%" }}
      onClick={() => {
        if (props.activeDropdown) {
          props.setActive(null);
        }
      }}
    >
      <div className="display-flex">
        <div style={initialsStyle} onClick={handleFileClick}>
          {name && (
            <div className="font-color-tertiaryColor6">{getInitials(name)}</div>
          )}
          {!name && (
            <div style={{ width: "fit-content", height: "fit-content" }}>
              <UserIcon width="16" height="16" color="var(--tertiaryColor6)" />
            </div>
          )}
        </div>
        <input
          ref={fileInputRef}
          type="file"
          accept=".jpg,.jpeg,.png"
          name="fileUploaderInput"
          onChange={handleFileChange}
          style={{ display: "none" }}
        />
        <div className="margin-left-medium display-flex flex-align-items-center font-color-tertiaryColor6">
          {name || "N/A"}
        </div>
      </div>
      <div
        className="edit-icon"
        onClick={() => {
          if (props.activeDropdown) {
            props.setActive(null);
          } else {
            props.setActive("profile");
          }
        }}
      >
        <PencilIcon color="var(--tertiaryColor6)" />
      </div>
    </div>
  );
}
